import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7111fdd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "assess-progress",
  class: "assessment-progress tw-bg-[#ffffff] tw-max-w-[241px] tw-p-[25px] tw-pr-[9.5px] tw-w-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1]"
}
const _hoisted_2 = { class: "sticky-header" }
const _hoisted_3 = { class: "tw-font-Poppins tw-text-[12px] tw-font-[600] tw-text-[#211F58] tw-uppercase tw-leading-[100%] tw-tracking-[1.2px]" }
const _hoisted_4 = {
  key: 0,
  class: "tw-w-full tw-mt-[15px] tw-pr-[10px]"
}
const _hoisted_5 = {
  colspan: "3",
  class: "sticky-searchbox-inner"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "tw-pr-[8px] tw-text-left tw-align-top tw-w-auto" }
const _hoisted_8 = { class: "tw-align-top tw-pr-[5px]" }
const _hoisted_9 = { class: "progress-text" }
const _hoisted_10 = { class: "tw-align-top tw-w-fit tw-pr-[5px]" }
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "tw-px-[5px] tw-py-[3px] tw-bg-[#E4F1FF] tw-text-[#211F58] tw-rounded-[4px] tw-text-[11px] tw-font-medium tw-font-[Poppins]" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ICategories } from "@/interfaces/assessments/ICategories";
import circularProgress from "./circularProgress.vue";
import {
  Ref,
  computed,
  onMounted,
  ref,
  watch,
  onBeforeMount,
  onUnmounted,
  nextTick,
} from "vue";
import store from "@/store";
import ArrowIcon from "../svgs/arrowIcon.vue";
import { getComponentUiText } from "@/utils/utilities";
import { localStorageKey } from "@/utils/constants";
import BaseSearchbox from "../common/form/baseSearchbox.vue";
import { debounce } from "lodash";

const NUMBER_SHOW_CATEGORIES = 5;

export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentProgress',
  props: {
  /** The title of assessment progress */
  title: {
    type: String,
    default: "",
  },
  /** Progress categories */
  progressCategories: {
    type: Array as () => ICategories[],
    default: () => [],
  },
},
  emits: ["scrollToTop"],
  setup(__props, { emit }) {

const props = __props;



const activeCategory = computed(() => store.state.Assessment.activeCategory);
const showAll: Ref<boolean> = ref(false);
const searchValue: Ref<string> = ref("");
const categoryFormatted: Ref<ICategories[]> = ref([]);
const searchboxRef = ref();

const handleCompleteValue = (categories: ICategories[]) => {
  categories.map(
    (c) =>
      (c.checklistItemCompletedPcntNumber = (Number(
        c.checklistItemCompletedPcnt,
      ) * 100) as number),
  );
};



const updateActiveCategory = async (category: ICategories) => {
  if (activeCategory.value === category.checklistItemCategoryId) return;
  localStorage.setItem(
    localStorageKey.assessmentActiveCategory,
    category.checklistItemCategoryId,
  );
  store.dispatch(
    "Assessment/changeActiveCategory",
    category.checklistItemCategoryId,
  );
  emit("scrollToTop");
};

const scrollToActiveCate = (index = 0) => {
  if (index < 3 || showAll.value) return;
  const scrollTop = (index - 2) * 43;
  const progressBox = document.getElementById("progress-box");
  if (!progressBox) return;
  progressBox.scrollTop = scrollTop;
};

const handleActiveCategory = () => {
  const activeIndex = props.progressCategories.findIndex(
    (cate) => cate.checklistItemCategoryId === activeCategory.value,
  );
  scrollToActiveCate(activeIndex);
};

const handleShowAll = () => {
  showAll.value = !showAll.value;
  searchValue.value = "";
  categoryFormatted.value = props.progressCategories.map((item, index) => ({
    ...item,
    indexLabel: index + 1 + ".",
  }));

  if (showAll.value) {
    nextTick(() => {
      // Focus the input inside BaseSearchbox when showAll is true
      // Try to access the input element inside BaseSearchbox
      const inputEl =
        searchboxRef.value?.$el?.querySelector("input") ||
        searchboxRef.value?.$refs?.input ||
        searchboxRef.value?.input;
      if (inputEl && typeof inputEl.focus === "function") {
        inputEl.focus();
      }
    });
  } else {
    setTimeout(() => {
      handleActiveCategory();
    }, 200);
  }
};

const handleFilterCategory = () => {
  if (!searchValue.value) {
    categoryFormatted.value = props.progressCategories.map((item, index) => ({
      ...item,
      indexLabel: index + 1 + ".",
    }));
    return;
  }

  categoryFormatted.value = props.progressCategories
    .map((item, index) => ({
      ...item,
      indexLabel: index + 1 + ".",
    }))
    .filter((item) =>
      item.checklistItemCategoryLabel
        .toLowerCase()
        .includes(searchValue.value.toLowerCase()),
    );
};

const handleNavigateToCategory = () => {
  if (categoryFormatted.value.length !== 1) return;
  updateActiveCategory(categoryFormatted.value[0]);
};

const actionsUpdateFilterCategory = debounce((value: string) => {
  searchValue.value = value;
  handleFilterCategory();
}, 300);

onBeforeMount(() => {
  const localActiveCategory = localStorage.getItem(
    localStorageKey.assessmentActiveCategory,
  );
  if (localActiveCategory) {
    store.dispatch("Assessment/changeActiveCategory", localActiveCategory);
  }
});

onMounted(() => {
  handleCompleteValue(props.progressCategories);
  handleFilterCategory();
});

onUnmounted(() => {
  localStorage.removeItem(localStorageKey.assessmentActiveCategory);
});

watch(() => activeCategory.value, handleActiveCategory);

watch(
  () => props.progressCategories,
  () => {
    handleCompleteValue(props.progressCategories);
    handleFilterCategory();
  },
);

watch(showAll, (val) => {
  if (val) {
    nextTick(() => {
      const inputEl =
        searchboxRef.value?.$el?.querySelector("input") ||
        searchboxRef.value?.$refs?.input ||
        searchboxRef.value?.input;
      if (inputEl && typeof inputEl.focus === "function") {
        inputEl.focus();
      }
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_b_popover = _resolveComponent("b-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
      (showAll.value)
        ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_5, [
                  _createVNode(BaseSearchbox, {
                    ref_key: "searchboxRef",
                    ref: searchboxRef,
                    class: _normalizeClass([
                  'md:tw-w-full tw-relative tw-h-[36px] tw-rounded-[6px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#FFFFFF] tw-p-[15px] tw-pr-[15px] search-box',
                ]),
                    "input-style": "tw-bg-[#FFFFFF] !tw-text-[13px] tw-mt-[1px]",
                    "icon-search-style": 'tw-scale-[0.867]',
                    "icon-close-style": 'tw-scale-[0.8]',
                    "model-value": searchValue.value,
                    placeholder: _unref(getComponentUiText)('app-header-search-prompt-1'),
                    "onUpdate:modelValue": _unref(actionsUpdateFilterCategory),
                    "onOn:focus": () => {},
                    "onOn:blur": () => {},
                    onKeyup: _withKeys(handleNavigateToCategory, ["enter"])
                  }, null, 8, ["model-value", "placeholder", "onUpdate:modelValue", "onKeyup"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("table", {
      id: "progress-box",
      class: _normalizeClass([
        'category-container tw-w-full tw-flex tw-flex-col tw-mb-0 tw-border-separate tw-border-spacing-y-[17px] 2xl:!tw-overflow-auto',
        showAll.value ? 'show-all' : 'show-less',
      ])
    }, [
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryFormatted.value, (item, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: index,
            class: _normalizeClass([
            'tw-cursor-pointer tw-select-none  tw-text-[15px] tw-text-[#211F58] tw-h-fit',
            activeCategory.value === item.checklistItemCategoryId
              ? 'tw-font-[600]'
              : '',
            index === categoryFormatted.value.length - 1 ? '' : '',
          ]),
            onClick: ($event: any) => (updateActiveCategory(item))
          }, [
            _createElementVNode("td", _hoisted_7, _toDisplayString(item.indexLabel), 1),
            _createElementVNode("td", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(item.checklistItemCategoryLabel), 1)
            ]),
            _createElementVNode("td", _hoisted_10, [
              _createElementVNode("span", {
                id: 
                'assessment-circular-progress-' + item.checklistItemCategoryId
              
              }, [
                _createVNode(circularProgress, {
                  class: _normalizeClass(['circular-progress']),
                  percent: item.checklistItemCompletedPcntNumber
                }, null, 8, ["percent"])
              ], 8, _hoisted_11),
              _createVNode(_component_b_popover, {
                target: 
                'assessment-circular-progress-' + item.checklistItemCategoryId
              ,
                triggers: "hover",
                placement: "right",
                "custom-class": "assessment-progress-popover",
                offset: 12,
                delay: {
                show: 0,
                hide: 100,
              },
                onShow: ($event: any) => (true)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", null, _toDisplayString(item.checklistItemCategoryLabel), 1),
                    _hoisted_13,
                    _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)(
                    "app-component-assessment-progress-tooltip-text-1",
                    false,
                    {
                      percent: Math.round(
                        item.checklistItemCompletedPcntNumber || 0,
                      ),
                    },
                  )), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["target"])
            ])
          ], 10, _hoisted_6))
        }), 128))
      ])
    ], 2),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass([
        'tw-select-none tw-cursor-pointer tw-flex tw-gap-[5px] tw-items-center tw-px-[5px] tw-text-[11px] tw-text-[#387DFF] tw-bg-[#F2F8FF] tw-font-medium tw-rounded',
      ]),
      onClick: handleShowAll
    }, [
      _withDirectives(_createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)(
          "app-component-assessments-progress-show-all-1",
          false,
          { numberCategoryHide: __props.progressCategories.length?.toString() },
        )), 513), [
        [_vShow, !showAll.value]
      ]),
      _withDirectives(_createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)("app-component-assessments-progress-hide-all-1")), 513), [
        [_vShow, showAll.value]
      ]),
      _createVNode(ArrowIcon, {
        class: _normalizeClass(['right-arrow tw-mr-[2px]', showAll.value ? 'show-all' : '']),
        width: 6,
        height: 9
      }, null, 8, ["class"])
    ], 512), [
      [_vShow, 
        searchValue.value.length === 0 &&
        __props.progressCategories.length > NUMBER_SHOW_CATEGORIES
      ]
    ])
  ]))
}
}

})